module.exports = __webpack_public_path__ + "static/media/sad_elon_musk.30184ce4.png";